import { render } from "./GlobalSearch.html?vue&type=template&id=fb9a16c0&scoped=true&ts=true&external"
import script from "./GlobalSearch.ts?vue&type=script&lang=ts&external"
export * from "./GlobalSearch.ts?vue&type=script&lang=ts&external"

import "./GlobalSearch.scss?vue&type=style&index=0&id=fb9a16c0&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9a16c0"]])

export default __exports__